import gql from 'graphql-tag';

const pendingVRAMutation = gql`
  mutation pendingVra($input: PendingVraInput!) {
    pendingVra(input: $input) {
      clientMutationId
      errors
      success
    }
  }
`;

export default pendingVRAMutation;
